module.exports = __webpack_public_path__ + "static/media/photosnap.3f34b49c.svg";